<template>
  <b-dropdown class="border rounded" variant="grey">
    <template #button-content>
      <i
        class="fa"
        :class="[usingBak && 'text-info', processingCls || 'fa-cog']"
      ></i>
      <span class="caret"></span>
    </template>
    <b-dropdown-form :style="sizeFromMenu">
      <template
        v-for="(topic, index) in data.headTopic"
        class="-col-group-container card-body card-body-scroll"
      >
        <ul class="-col-group" name="ColumnGroup" :key="index">
          <label class="-col-group-title">{{ topic }}</label>
          <div class="row">
            <div class="col">
              <div class="checkbox-animated">
                <label
                  class="d-block"
                  for="chk-ani"
                  v-for="(col, index) in data.columns"
                  :key="index"
                >
                  <template v-if="col.topic == topic">
                    <input
                      class="checkbox_animated"
                      id="chk-ani"
                      type="checkbox"
                      v-model="col.visible"
                      @change="selectField(col.field, col.visible)"
                    />
                    {{ col.label }}
                  </template>
                </label>
              </div>
            </div>
          </div>
        </ul>
      </template>
    </b-dropdown-form>
  </b-dropdown>
</template>
<style scoped>
  .card-body-scroll {
    width: 60vh;
    overflow-y: scroll;
    overflow-x: scroll;
  }
  .b-dropdown-form {
    display: inline-block;
    padding: 0px 0px 0px 1.5rem !important;
    width: 100%;
    clear: both;
    font-weight: 400;
  }
  .-col-group-container {
    border-bottom: 1px solid #ddd;
  }
  .-col-group {
    display: inline-block;
    margin-bottom: 5px;
    padding: 0;
    width: 200px;
    vertical-align: top;
  }
  .-col-group-title {
    display: block;
    margin: 5px;
    padding: 5px;
    border-bottom: 1px solid #ddd;
    font-size: 18px;
  }
  .-col-group > li {
    margin-bottom: 5px;
    padding-left: 10px;
    list-style: none;
    line-height: 20px;
    font-size: 12px;
  }
  .-col-group > li > * {
    margin: 0;
    vertical-align: middle;
  }
</style>
<script>
  export default {
    name: 'HeaderSettingDatatable',
    props: {
      data: Object,
    },

    data() {
      return {
        usingBak: false,
        processingCls: '',
        checkBoxInput: {},
      };
    },
    computed: {
      sizeFromMenu() {
        const w = Object.keys(this.data.headTopic).length * 160;
        return {
          width: `${w + 25}px`,
          left: `-${w - 25}px`,
        };
      },
    },
    mounted() {},
    methods: {
      selectField(field, e) {
        this.data.columns.forEach((element) => {
          if (element.field == field) {
            element.hidden = !e;
          }
        });
      },
    },
  };
</script>
